module.exports = __webpack_public_path__ + "img/SES_210420560.d3d10044.jpg";